module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "key-holder"
  }, [_c('div', {
    staticClass: "keys"
  }, _vm._l((_vm.keys), function(key) {
    return _c('button', {
      class: key.class,
      attrs: {
        "data-note": key.note
      },
      on: {
        "pointerup": function($event) {
          return _vm.mouseUp($event)
        },
        "pointerdown": function($event) {
          return _vm.mouseDown($event)
        },
        "pointerover": function($event) {
          return _vm.mouseOver($event)
        },
        "pointerout": function($event) {
          return _vm.mouseOut($event)
        }
      }
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10f0ebe0!./src/components/keyboard/keyboard.html
// module id = 110
// module chunks = 2